// Fuente única de los colores de aspectos.
// Los 7 aspectos se agrupan en 4 colores según su naturaleza:
//   conjunción -> verde | cuadratura + oposición -> violeta (tensos)
//   trígono + sextil -> celeste (fluidos) | semisextil + quincuncio -> amarillo (menores)
//
// La web toma los valores vía variables CSS (App.css los redefine en dark),
// así que acá sólo viven las referencias var(). Los hexes de abajo son para
// contextos que NO resuelven variables CSS (react-pdf) o que necesitan el
// valor crudo; deben quedar sincronizados con App.css.

// Paleta clara: más saturada, para leerse sobre fondo blanco.
export const PALETA_ASPECTOS_LIGHT = {
  conjuncion: '#3df29b',
  cuadratura: '#b24dff',
  trigono: '#59bbff',
  semisextil: '#fad13f',
};

// Paleta oscura: versiones más claras/pastel, para leerse sobre fondo negro.
export const PALETA_ASPECTOS_DARK = {
  conjuncion: '#8ef7c4',
  cuadratura: '#d194ff',
  trigono: '#8acfff',
  semisextil: '#ffd84d',
};

// Qué color base le corresponde a cada aspecto.
const GRUPO_POR_ASPECTO = {
  conjuncion: 'conjuncion',
  cuadratura: 'cuadratura',
  oposicion: 'cuadratura',
  trigono: 'trigono',
  sextil: 'trigono',
  semisextil: 'semisextil',
  quincuncio: 'semisextil',
};

const grupoDe = (aspecto) => GRUPO_POR_ASPECTO[aspecto] || 'conjuncion';

// Mapa para la web: aspecto -> var(--aspecto-*). Cambia solo con el tema.
export const coloresAspectos = Object.keys(GRUPO_POR_ASPECTO).reduce((acc, aspecto) => {
  acc[aspecto] = `var(--aspecto-${grupoDe(aspecto)})`;
  return acc;
}, {});

// Mapa para el PDF: siempre fondo blanco, así que usa la paleta clara.
export const coloresAspectosPdf = Object.keys(GRUPO_POR_ASPECTO).reduce((acc, aspecto) => {
  acc[aspecto] = PALETA_ASPECTOS_LIGHT[grupoDe(aspecto)];
  return acc;
}, {});

// Helpers tolerantes: un aspecto desconocido cae en el verde de conjunción.
export const colorDeAspecto = (aspecto) => coloresAspectos[grupoDe(aspecto)];
export const colorDeAspectoPdf = (aspecto) => coloresAspectosPdf[grupoDe(aspecto)];
